import { Injectable } from '@angular/core';

@Injectable()
export class MapaService {

    constructor() { }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/mapa/mapa.service.ts
 **/